import type { FC, PropsWithChildren } from "react";

import classNames from "classnames";

import styles from "./SecondaryNavigation.module.scss";

export type SecondaryNavigationProps = {
  className?: string;
};

export const SecondaryNavigation: FC<PropsWithChildren<SecondaryNavigationProps>> = ({ children, className }) => {
  return (
    <div className={classNames(styles.wrapper, className)}>
      <div className={styles.innerWrapper}>{children}</div>
    </div>
  );
};
